export const NAME_APP: string = 'ElectronicOffice';
export const STORAGE_THEME = `${NAME_APP}useThemeSelected`;
export const CONTEXTS_APP = `${NAME_APP}contextsApp`;
export const STORAGE_LANGUAGE = `${NAME_APP}Language`;
export const STORAGE_FEATURES_TOGGLE = `${NAME_APP}FeaturesToggle`;
export const IS_DEV = process.env.NODE_ENV === 'development';